/*
* Styles Component de CadastroServicos
*/
import styled from 'styled-components';

export const Container = styled.div`
    min-height: 100%;
    background: #eef8fd;
    display: flex;
    flex-direction: row;

`;


